export default __webpack_public_path__ + "static/media/photo-charte06.d7acb1b8.png";